export default __webpack_public_path__ + "static/media/Logo.6897b0b6.png";